module.exports = __webpack_public_path__ + "media/images/logo-8724725f9c74bb7fd481f0755b30b3f8.png";